var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWarning(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 16,
    viewBox: "0 0 15 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.5 0.5C3.35786 0.5 0 3.85786 0 8C0 12.1421 3.35786 15.5 7.5 15.5C11.6421 15.5 15 12.1421 15 8C15 3.85786 11.6421 0.5 7.5 0.5ZM7.49992 3.92857C7.94964 3.92857 8.31421 4.29314 8.31421 4.74285V8.40714C8.31421 8.85686 7.94964 9.22142 7.49992 9.22142C7.05021 9.22142 6.68564 8.85686 6.68564 8.40714V4.74285C6.68564 4.29313 7.05021 3.92857 7.49992 3.92857ZM7.49992 12.0714C7.05021 12.0714 6.68564 11.7069 6.68564 11.2571C6.68564 10.8074 7.05021 10.4429 7.49992 10.4429C7.94964 10.4429 8.31421 10.8074 8.31421 11.2571C8.31421 11.7069 7.94964 12.0714 7.49992 12.0714Z",
    fill: "inherit"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarning);
export default __webpack_public_path__ + "static/media/warning.487d0bb085df8bff0f9318c800f86b1b.svg";
export { ForwardRef as ReactComponent };